export default __webpack_public_path__ + "static/media/049.20db21fb.jpg";